import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchToken } from './store/appConfig-actions';

import QuoterContainer from './containers/QuoterContainer';
import FooterContainer from './containers/FooterContainer';
import NavbarContainer from './containers/NavbarContainer';
import OverlayContainer from './containers/OverlayContainer';

let tokenRequested = false;

const App = () => {
  const dispatch = useDispatch();
  const uiStatus = useSelector((state) => state.ui.uiStatus);
  let appClasses = 'main-app';

  switch (uiStatus) {
    case 'error':
      appClasses += ' -with-error';
      break;
    case 'loading':
      appClasses += ' -with-loader';
      break;
    default:
      break;
  }

  const renderAppOverlay = () => {
    if (uiStatus !== '') {
      return <OverlayContainer />;
    }
    return '';
  };

  useEffect(() => {
    if (!tokenRequested) {
      tokenRequested = true;
      dispatch(fetchToken());
    }
  }, [dispatch]);

  return (
    <div className={appClasses}>
      <NavbarContainer />
      {renderAppOverlay()}
      <QuoterContainer />
      <FooterContainer />
    </div>
  );
};

export default App;
